import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";

const issuer = (import.meta.env.VITE_ZITADEL_ISSUER as string | undefined)?.replace(/\/+$/, "") ?? "";
const clientId = (import.meta.env.VITE_ZITADEL_CLIENT_ID as string | undefined) ?? "";
const projectId = (import.meta.env.VITE_ZITADEL_PROJECT_ID as string | undefined) ?? "";

export const authConfigured = Boolean(issuer && clientId && projectId);

let manager: UserManager | undefined;

function userManager(): UserManager {
  if (!authConfigured) throw new Error("Zitadel OIDC is not configured");
  manager ??= new UserManager({
    authority: issuer,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: "code",
    scope: `openid profile email urn:zitadel:iam:org:projects:roles urn:zitadel:iam:org:project:id:${projectId}:aud`,
    automaticSilentRenew: true,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
  return manager;
}

export async function currentUser(): Promise<User | null> {
  if (!authConfigured) return null;
  const user = await userManager().getUser();
  return user && !user.expired ? user : null;
}

export async function signIn(): Promise<void> {
  await userManager().signinRedirect();
}

export async function completeSignIn(): Promise<User> {
  return userManager().signinRedirectCallback();
}

export async function signOut(): Promise<void> {
  await userManager().signoutRedirect();
}

export async function accessToken(): Promise<string> {
  const user = await currentUser();
  if (!user) throw new Error("Authentication is required");
  return user.access_token;
}
